import React from 'react';
import IconSix from '../../assets/images/icons/clinic/landing/10.png';
import IconOne from '../../assets/images/icons/clinic/landing/5.png';
import IconTwo from '../../assets/images/icons/clinic/landing/6.png';
import IconThree from '../../assets/images/icons/clinic/landing/7.png';
import IconFour from '../../assets/images/icons/clinic/landing/8.png';
import IconFive from '../../assets/images/icons/clinic/landing/9.png';
function ServicesHomeTwo({ className }) {
    return (
        <>
            <section className={`appie-services-2-area pb-100 ${className}`} id="service">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-md-8">
                            <div className="appie-section-title">
                                <h3 className="appie-title">Why Use Supermedic</h3>
                                <p>
                                Hire with confidence, choose from a large pool of qualified applicants.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                <img src={IconOne} alt="" style={{height: 50}} />
                                </div>
                                <h4 className="title">Healthcare-Exclusive Platform</h4>
                                <p>
                                We connect you only with qualified healthcare professionals — doctors, nurses, pharmacists, and allied health talent. No irrelevant candidates, just the right fit for your needs.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-2 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                <img src={IconTwo} alt="" style={{height: 50}} />
                                </div>
                                <h4 className="title">Flexible Staffing Options</h4>
                                <p>
                                Post locum shifts, contract roles, or full-time positions. Whether you need urgent cover, seasonal support, or permanent staff, Supermedic adapts to your hiring needs.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-3 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                <img src={IconThree} alt="" style={{height: 50}} />
                                </div>
                                <h4 className="title">Direct Access to Talent</h4>
                                <p>
                                Engage directly with healthcare professionals through our platform. No unnecessary middlemen, just transparent communication and faster placements.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-4 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                <img src={IconFour} alt="" style={{height: 50}} />
                                </div>
                                <h4 className="title">Fast and Reliable Coverage</h4>
                                <p>
                                Fill last-minute shifts quickly with ready-to-work locums. Our system ensures your facility never faces staffing gaps that impact patient care.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-5 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                <img src={IconFive} alt="" style={{height: 50}} />
                                </div>
                                <h4 className="title">Global Reach, Local Expertise</h4>
                                <p>
                                Hire locally in Malaysia, Singapore, Indonesia, and the Philippines, or tap into international healthcare recruitment pipelines for overseas placements.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 item-6 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                <img src={IconSix} alt="" style={{height: 50}} />
                                </div>
                                <h4 className="title">Simple, Transparent Process</h4>
                                <p>
                                Job posts are clear and structured — role type, schedule, location, and requirements — making hiring decisions straightforward and efficient.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ServicesHomeTwo;
